{
  "admin": {
    "title": "Admin",
    "dashboard": "Übersicht",
    "clientsManagement": "Mandantenverwaltung",
    "usersManagement": "Benutzerverwaltung",
    "conversationOverview": "Gesprächsübersicht",
    "aiManagement": "KI-Verwaltung",
    "globalLogs": "Globale Protokolle",
    "globalSettings": "Globale Einstellungen"
  },
  "manage": {
    "title": "Manager",
    "dashboard": "Übersicht",
    "calendar": "Kalender",
    "tasksProjects": "Aufgaben & Projekte",
    "knowledgeHub": "Wissensdatenbank",
    "videoMeetings": "Videokonferenzen",
    "communicationThreads": "Kommunikations-Threads",
    "leads": "Leads",
    "customers": "Kunden",
    "reminders": "Erinnerungen",
    "customersLeads": "Kunden & Leads",
    "aiModules": "KI-Automatisierungsmodule",
    "myCompany": "Mein Unternehmen",
    "resources": "Ressourcen",
    "services": "Dienstleistungen",
    "employees": "Mitarbeiter",
    "companiesAndEmployees": "Unternehmen / Mitarbeiter",
    "settings": "Einstellungen",
    "booking": "Buchung",
    "shop": "Shop",
    "permissions": "Berechtigungen",
    "externalModules": "Externe Module",
    "helpers": "Helfer"
  },
  "client": {
    "title": "Kunde",
    "dashboard": "Übersicht",
    "myCalendar": "Mein Kalender",
    "communications": "Kommunikation",
    "myProfile": "Mein Profil"
  }
}
